import { render, staticRenderFns } from "./customer-opsmanager-assessment-create.vue?vue&type=template&id=12c8582f&"
import script from "./customer-opsmanager-assessment-create.vue?vue&type=script&lang=js&"
export * from "./customer-opsmanager-assessment-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports